import { useInfiniteQuery } from '@tanstack/react-query';

import { HouseListSortType } from '@/lib/coloc-api/admin';
import { useDebounce } from '@/hooks/use-debounce';
import { useColocApi } from '@/hooks/use-coloc-api';
import { getHouseList } from '@/services/coloc-api/admin';

const useGetHousesInfinite = (params: { searchQuery?: string, household?: boolean }) => {
  const { setPage, setPageLimit, page, pageLimit } =
    useColocApi<HouseListSortType>()!;
  const debouncedSearchQuery: string = useDebounce(
    params.searchQuery ?? '',
    500
  );

  const fetch = useInfiniteQuery({
    queryKey: ['getHouseList', debouncedSearchQuery, params.household, page, pageLimit],
    queryFn: ({ pageParam = 1 }) =>
      getHouseList({
        page_limit: 5,
        sort: 'name',
        ...(params.household && { household: params.household }),
        ...(pageParam && { page: pageParam }),
        ...(debouncedSearchQuery &&
          debouncedSearchQuery !== '' && { query: debouncedSearchQuery }),
      }),
    keepPreviousData: true,
    getNextPageParam: (lastPage, pages) => {
      if (lastPage.data.pagination.total_pages > pages.length) {
        return pages.length + 1;
      }

      return undefined;
    },
  });

  return {
    pageLimit,
    setPageLimit,
    fetch,
    setPage,
  };
};

export { useGetHousesInfinite };
